
import { Component, OnInit } from '@angular/core';
import {
  BatchPostingCSVDetailsResponseDto,
  BatchPostingFileSummaryDto,
  BatchPostingService,
  DateUtilsService
} from 'remarketing-angular-library';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

import { TranslocoService } from '@jsverse/transloco';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { PostingFileDetailsExportService } from '../../services/posting-file-details-export.service';
import { PostingFileDetailsExportServiceProvider } from '../../services/posting-file-details-export.service.provider';
import { DatalistItemComponent, SpinnerComponent } from 'remarketing-ui-components-lib';


@Component({
    selector: 'app-update-in-service-vehicles-file-details',
    templateUrl: './upload-in-service-vehicles-file-details.component.html',
    styleUrls: ['./upload-in-service-vehicles-file-details.component.scss'],
    providers: [PostingFileDetailsExportServiceProvider],
    imports: [DatalistItemComponent, SpinnerComponent]
})
export class UploadInServiceVehiclesFileDetailsComponent extends SaComponent implements OnInit {
  public batchPostingFileSummaryDto: BatchPostingFileSummaryDto;
  public downloading = false;
  private readonly uploadInServiceVehicleFileDetailsTranslations = {
    header: '',
    vehiclesInFile: '',
    errors: '',
    newVehiclesAdded: '',
    updatedVehicles: '',
    vehiclesRemoved: '',
    downloadText: '',
    fullFile: '',
    partialFile: ''
  };
  private fileUuid = '';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly translocoService: TranslocoService,
    private readonly batchPostingService: BatchPostingService,
    private readonly dateUtilService: DateUtilsService,
    private readonly postingFileDetailsExportService: PostingFileDetailsExportService
  ) {
    super();
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.getFileSummary(params['fileUuid']);
    });
    this.getTranslations();
  }

  getTranslations(): void {
    const keyParams = {
      'uploadInServiceVehicles.uploadInServiceVehiclesFileDetails': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translate => {
        this.uploadInServiceVehicleFileDetailsTranslations.header = translate[0].header;
        this.uploadInServiceVehicleFileDetailsTranslations.vehiclesInFile = translate[0].vehiclesInFile;
        this.uploadInServiceVehicleFileDetailsTranslations.errors = translate[0].errors;
        this.uploadInServiceVehicleFileDetailsTranslations.newVehiclesAdded = translate[0].newVehiclesAdded;
        this.uploadInServiceVehicleFileDetailsTranslations.updatedVehicles = translate[0].updatedVehicles;
        this.uploadInServiceVehicleFileDetailsTranslations.vehiclesRemoved = translate[0].vehiclesRemoved;
        this.uploadInServiceVehicleFileDetailsTranslations.downloadText = translate[0].downloadText;
        this.uploadInServiceVehicleFileDetailsTranslations.fullFile = translate[0].fullFile;
        this.uploadInServiceVehicleFileDetailsTranslations.partialFile = translate[0].partialFile;
      });
  }

  getFileSummary(fileUuid: string): void {
    this.fileUuid = fileUuid;
    this.batchPostingService.getBatchPostingFileSummary(fileUuid).subscribe(batchPostingFileSummaryDto => {
      this.batchPostingFileSummaryDto = batchPostingFileSummaryDto;
    });
  }

  public downloadClicked(): void {
    this.downloading = true;
    this.batchPostingService
      .getBatchInServiceVehicleCSVDetails(this.fileUuid)
      .subscribe((dto: BatchPostingCSVDetailsResponseDto) => {
        if (dto) {
          this.postingFileDetailsExportService
            .createCSVFile(dto)
            .then(() => {
              console.log('CSV downloadeded.');
              this.downloading = false;
            })
            .catch(err => {
              console.log(err);
              this.downloading = false;
            });
        }
      });
  }

  public formatDate(date: Date) {
    return this.dateUtilService.localizeDateAndTime(date);
  }

  public getFileInfo(): string {
    return `${
      this.batchPostingFileSummaryDto.fileType === 'FULL'
        ? this.uploadInServiceVehicleFileDetailsTranslations.fullFile
        : this.uploadInServiceVehicleFileDetailsTranslations.partialFile
    }
      (${this.batchPostingFileSummaryDto.fileName}) ${this.formatDate(this.batchPostingFileSummaryDto.completedAt)}`;
  }
}
